import { Http } from "./http.js"

export class PlayList {

    constructor(player,playlist){
        console.log(this)
        window.playlist = this
        this.player = player
        this.playlist
        this.index = 0
        this.loadPlaylist(playlist)
        console.table(playlist)
        // setInterval(() => {
        //     this.checkPlaylist()
        // }, 30000);

    }
   /**
    * Plays items in playlist
    * @param {*} item
    * @returns
    */
    play(item = this.playlist[this.index]){
        console.log(item,playlist.index, playlist.playlist.length)
        if(item.type === 'background') playlist.index++
        const next = () => {
            if(playlist.index === playlist.playlist.length-1)
                playlist.index = 0
            else
                playlist.index++  // set next item
        }

        if(item?.duration){
            if(typeof item.duration === 'string')
                item.duration = this.convertItemDuration(item.duration)
            this.item()
            this.playlistTimeOut = setTimeout(() => { // set duration
                next()
                this.play()
            },item.duration)
            return
        }else{
            next()
            this.item()
            this.play()
        }
    }
    /**
     * Convert HH:mm:ss string to ms number
     * @param {*} duration
     * @returns {number}
     */
    convertItemDuration (duration) {
        duration = duration.split(':');
        const seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]);
        return ( seconds * 1000 ) // return ms
    }
    /**
     * Sends playlist item to player
     * @param {*} item
     */
    item(item = playlist.playlist[playlist.index]){
        let appendItem
        switch (item.type) {
            case 'video':
                //appendItem = this.player.createVideo(item)
                item.asVideo = true
                appendItem = player.createIframe(item)
                break
            case 'image':
                appendItem = player.createImage(item)
                break
            case 'iframe':
                appendItem = player.createIframe(item)
                break
            case 'command': // { command : 'ticker.remove' }
                const command = item.command.split(':')[0].split('.'),
                      value = item.command.contains(':') ? item.command.split(':')[1] : null,
                      exec = command.length ? player[command[0]][command[1]] : player[command]
                exec(value)
                break
            default:
                break
        }

        if(appendItem) {
            //appendItem.style.display = 'none'
            player.clear()
            player.player.appendChild(appendItem)
            console.log(item.transition)
            //$(appendItem).effect(item.transition,'slow')
        }
    }
    /**
     * Checks for new playlist
     * @param {*} id
     */
    checkPlaylist(id){
        const request = new Http,
              REQUEST_URL = 'https://cms.display-booster.com/api/player_queue_check',
              requestBody = data => {
                    return {
                        player_id : data.player_id,
                        current_queue_id : data.playlist_queue_id
                    }
              },
              nextQueue = response => {
                const next_queue_id = response.next_queue_id
                if(next_queue_id){
                    // We have a new playlist to be fetched so upgrade and reboot the app
                    this.player.webOS.LG_upgradeApp()
                }else{
                    console.log(response.message)
                }
              }
        request.get('./player_data.json', data => {
            request.post(REQUEST_URL,requestBody(data),response =>{
                nextQueue(response)
            },()=>{
                // POST request has failed so send request via JSONP
                request.JSONP(REQUEST_URL,nextQueue)
            })
        })

    }
    /**
     * Loads new playlist
     * @param {*} playlist
     */
    loadPlaylist(playlist){

        // load playlist json
        const request = new Http,
              JSON_FILE_PATH = playlist

       if(Array.isArray(playlist)){
            this.playlist = playlist
            this.play()
       }else if(typeof JSON_FILE_PATH === 'string'){
        request.get(JSON_FILE_PATH, data => {
            // set the playlist with JSON data

            this.playlist = data
            console.log(data)
            this.play()
        })
       }
    }

    stop() {
        clearTimeout(this.playlistTimeOut);
    }

}
